import { createModuleLayout } from "@/lib/create-module-layout";
import { MODULES } from "@kubdee/shared/module-ids";
import salesModule from "@kubdee/module-sales";

export default createModuleLayout({
  moduleId: MODULES.SALES,
  moduleConfig: salesModule,
});
